function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTumblrinline = function SvgTumblrinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11 0a11 11 0 1 0 11 11A11 11 0 0 0 11 0Zm4 16.274a4.6 4.6 0 0 1-1.442.581 8.809 8.809 0 0 1-1.441.145 3.873 3.873 0 0 1-1.369-.22 3 3 0 0 1-1.153-.654 3.416 3.416 0 0 1-.649-.871 3.438 3.438 0 0 1-.216-1.38V9.3H7V7.486a4.5 4.5 0 0 0 1.441-.726 3.211 3.211 0 0 0 .868-1.09A5.12 5.12 0 0 0 9.741 4h1.8v3.123H14.5v2.324h-2.955v3.341c0 1.537.114 1.678.572 1.961a1.663 1.663 0 0 0 1.009.145A4.091 4.091 0 0 0 15 14.24v2.034Z",
    style: {
      fill: "#282828",
      fillRule: "evenodd"
    }
  }));
};
export default SvgTumblrinline;